module.exports = __webpack_public_path__ + "static/media/02-night.71aa650e.png";